export const euMetricValue = (point, metric) => {
  if (!point) return null;
  if (metric === 'net') return point.net ?? null;
  if (metric === 'tax') return point.tax_amount ?? point.tax ?? null;
  return point.gross ?? null;
};

export const formatSignedCents = (value, digits = 1) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return '—';
  const cents = Number(value) * 100;
  const sign = cents > 0 ? '+' : cents < 0 ? '−' : '';
  return `${sign}${new Intl.NumberFormat('it-IT', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Math.abs(cents))} c€/l`;
};

export const formatTaxShare = (value) => value === null || value === undefined
  ? '—'
  : `${new Intl.NumberFormat('it-IT', { minimumFractionDigits: 1, maximumFractionDigits: 1 }).format(Number(value))}%`;

export const metricLabels = {
  gross: 'Alla pompa',
  net: 'Senza tasse',
  tax: 'Fiscalità',
};

export const viewLabels = {
  nominal: 'Nominale',
  cost_of_living: 'Costo della vita',
  affordability: 'Accessibilità',
};

export const euViewValue = (point, view, metric = 'gross') => {
  if (!point) return null;
  if (view === 'cost_of_living') return point.cost_of_living_index ?? null;
  if (view === 'affordability') return point.tank_income_share ?? null;
  return euMetricValue(point, metric);
};

export const formatIndex = (value, digits = 1) => value === null || value === undefined
  ? '—'
  : new Intl.NumberFormat('it-IT', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(value));

export const formatPercent = (value, digits = 2) => value === null || value === undefined
  ? '—'
  : `${new Intl.NumberFormat('it-IT', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(value))}%`;

export const formatLitres = (value, digits = 1) => value === null || value === undefined
  ? '—'
  : `${new Intl.NumberFormat('it-IT', { minimumFractionDigits: digits, maximumFractionDigits: digits }).format(Number(value))} l`;

export const formatEuViewValue = (value, view) => {
  if (view === 'cost_of_living') return formatIndex(value);
  if (view === 'affordability') return formatPercent(value);
  if (value === null || value === undefined) return '—';
  return `${new Intl.NumberFormat('it-IT', { minimumFractionDigits: 3, maximumFractionDigits: 3 }).format(Number(value))} €/l`;
};
